import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, TextField, Button, Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Header from "../../../src/components/Header";
import Footer from "../../../src/components/Footer";

function VerifyCert() {
    const [certId, setCertId] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const validateCertId = (id) => /^CSN-.+$/i.test(id);

    const handleChange = (e) => {
        setCertId(e.target.value);
        setError(""); // Reset error while typing
    };

    const handleSubmit = () => {
        if (!validateCertId(certId)) {
            setError("Invalid Certification ID. Format should be: CSN-xxxxx");

            // Auto-dismiss the error after 4 seconds
            setTimeout(() => setError(""), 4000);
            return;
        }
        navigate(`/certificate/view/${certId}`);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                backgroundColor: "#ffffff",
            }}
        >
            {/* Header */}
            <Header />

            {/* Main Content */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "2rem",
                }}
            >
                {/* Heading */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: "bold",
                        marginBottom: "1rem",
                        textAlign: "center",
                        color: "#333",
                    }}
                >
                    Verify Certificate
                </Typography>

                {/* Description */}
                <Typography
                    variant="body1"
                    sx={{
                        marginBottom: "2rem",
                        textAlign: "center",
                        color: "text.secondary",
                    }}
                >
                    Enter the Certification ID below to verify your completion certificate.
                </Typography>

                {/* Error Alert - Only show after submit & allow dismiss */}
                {error && (
                    <Alert
                        severity="error"
                        sx={{ mb: 2, maxWidth: "500px", width: "100%" }}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => setError("")} // Dismiss on click
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {error}
                    </Alert>
                )}

                {/* Input and Button */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                        maxWidth: "500px",
                    }}
                >
                    <TextField
                        fullWidth
                        placeholder="Certification ID"
                        variant="outlined"
                        size="medium"
                        value={certId}
                        onChange={handleChange}
                        error={!!error} // Highlights field if invalid
                        sx={{
                            flex: 1,
                            backgroundColor: "#fff",
                            marginTop: "2px",
                            height: "56px",
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "56px",
                            padding: "0 28px",
                            width: { xs: "100%", sm: "auto" },
                            alignSelf: { xs: "center", sm: "auto" },
                        }}
                        endIcon={<OpenInNewIcon />}
                        onClick={handleSubmit}
                        disabled={!certId} // Disabled if input is empty
                    >
                        Verify
                    </Button>
                </Box>
            </Box>

            {/* Footer */}
            <Footer />
        </Box>
    );
}

export default VerifyCert;
